import { asString, loadedDefinedMap } from "common/components/component-helpers";
import type { AppOther, AppEnvironment } from "common/components/types";
import { LOADING, ActionSource } from "common/components/types";
import type { GlideFunctionalRenderer } from "common/components/uis";
import { Data } from "common/components/data";
import Chat from "../ui/smart/chat/chat";
import { forceComments, forceUserProfiles } from "./comments-material-renderer";
import { useForce } from "hooks/use-force";
import { useForceValueProducers } from "hooks/use-value-producers";
import { dontAwait } from "@glideapps/ts-necessities";
import { useOnClickFromAction } from "hooks/use-on-click-from-action";

export const ChatMaterialRenderer: GlideFunctionalRenderer = p => {
    const { env, getValueProducers, ctx } = p;
    const [force] = useForce();
    const [[comments, onPost, onTapNew, onDelete, topic, userProfiles]] = useForceValueProducers(
        getValueProducers,
        force,
        ctx
    );
    const { onClickWithCustomContext: onClickDelete } = useOnClickFromAction(
        onDelete,
        ActionSource.DeleteComments,
        ctx,
        env
    );
    const { onClick: onTap } = useOnClickFromAction(onTapNew, ActionSource.Note, ctx, env);
    const { onClickWithCustomContext: onClickPost } = useOnClickFromAction(onPost, ActionSource.PostComment, ctx, env);
    if (comments === LOADING) {
        return null;
        // return Comments.renderSkeleton();
    }
    if (comments === undefined) return null;
    const processedComments = forceComments(comments, force);

    const profiles = forceUserProfiles(userProfiles, force);

    const deleteComments =
        onClickDelete !== undefined && env.appEnvironment.isBuilder
            ? (documentIDs: ReadonlyArray<string>) => {
                  dontAwait(onClickDelete(Data.fromJSON<AppOther, AppEnvironment>(documentIDs), undefined));
              }
            : undefined;

    const postComment =
        onClickPost !== undefined
            ? (username: string, email: string | undefined, comment: string) => {
                  dontAwait(
                      onClickPost(Data.fromJSON<AppOther, AppEnvironment>({ username, email, comment }), undefined)
                  );
              }
            : undefined;

    return (
        <Chat
            appEnvironment={env.appEnvironment}
            renderEnvironment={env}
            comments={processedComments}
            onTapNew={onTap !== undefined ? () => onTap(undefined) : undefined}
            postComment={postComment}
            deleteComments={deleteComments}
            topic={loadedDefinedMap(topic, asString)}
            userProfiles={profiles}
        />
    );
};
